export default __webpack_public_path__ + "static/media/Belt of the Firebrand.3eb09b3b.jpg";